export enum WorkloadTypes {
  TOTAL = 1,
  PER_CASE = 2,
}
